var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#F8F9FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "#E1E6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 29.5H31.25C30.3221 29.501 29.4324 29.8701 28.7762 30.5262C28.1201 31.1824 27.751 32.0721 27.75 33V47C27.751 47.9279 28.1201 48.8176 28.7762 49.4738C29.4324 50.1299 30.3221 50.499 31.25 50.5H48.75C49.6779 50.499 50.5676 50.1299 51.2238 49.4738C51.8799 48.8176 52.249 47.9279 52.25 47V33C52.249 32.0721 51.8799 31.1824 51.2238 30.5262C50.5676 29.8701 49.6779 29.501 48.75 29.5V29.5ZM44.375 33C44.8942 33 45.4017 33.154 45.8334 33.4424C46.265 33.7308 46.6015 34.1408 46.8002 34.6205C46.9989 35.1001 47.0508 35.6279 46.9496 36.1371C46.8483 36.6463 46.5983 37.114 46.2312 37.4812C45.864 37.8483 45.3963 38.0983 44.8871 38.1996C44.3779 38.3008 43.8501 38.2489 43.3705 38.0502C42.8908 37.8515 42.4808 37.5151 42.1924 37.0834C41.904 36.6517 41.75 36.1442 41.75 35.625C41.7507 34.929 42.0275 34.2618 42.5196 33.7696C43.0118 33.2775 43.679 33.0007 44.375 33V33ZM31.25 48.75C30.7859 48.75 30.3408 48.5656 30.0126 48.2374C29.6844 47.9092 29.5 47.4641 29.5 47V43.3015L34.6866 38.6913C35.187 38.2475 35.8378 38.0112 36.5064 38.0305C37.175 38.0498 37.811 38.3233 38.285 38.7952L41.837 42.3395L35.4265 48.75H31.25ZM50.5 47C50.5 47.4641 50.3156 47.9092 49.9874 48.2374C49.6592 48.5656 49.2141 48.75 48.75 48.75H37.9016L44.5418 42.1098C45.0119 41.71 45.6085 41.4898 46.2257 41.4882C46.8428 41.4866 47.4405 41.7037 47.9127 42.1011L50.5 44.2569V47Z",
    fill: "#1D2433",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/defaultImg.362e1a91ac7462fc343b2e7973095a88.svg";
export { ForwardRef as ReactComponent };